var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQuery } from "react-query";
import { SurveyApi } from "../../services";
export const useAvailableSurveysStatus = (userUuid, ciamToken) => {
    const fetchSurveysStatus = () => __awaiter(void 0, void 0, void 0, function* () {
        if (userUuid && ciamToken) {
            const response = yield SurveyApi.init().getAvailableSurveys(userUuid, ciamToken);
            return response;
        }
        return Promise.reject(new Error("Something went wrong"));
    });
    const { data, isLoading, isError, error, refetch } = useQuery(["surveysStatus", userUuid, ciamToken], fetchSurveysStatus, {
        enabled: !!ciamToken && !!userUuid,
        retry: 3,
        retryDelay: 500,
        refetchOnWindowFocus: false,
    });
    return {
        refetch,
        surveysStatus: data,
        surveyStatusError: error,
        isSurveysStatusError: isError,
        isSurveysStatusLoading: isLoading,
    };
};
export const useStartSurvey = () => {
    const fetchStartSurvey = (_a) => __awaiter(void 0, [_a], void 0, function* ({ userUuid, ciamToken, survey_id, userInputCode }) {
        const response = yield SurveyApi.init().startSurvey(userUuid, ciamToken, survey_id, userInputCode);
        return response;
    });
    const { isError, isLoading, mutateAsync, error, reset } = useMutation(fetchStartSurvey);
    return {
        resetStartSurvey: reset,
        startSurvey: mutateAsync,
        startSurveyError: error,
        isStartSurveyError: isError,
        isStartSurveyLoading: isLoading,
    };
};
export const useValidateSurveySerialCode = () => {
    const { isError, isLoading, mutateAsync, error, reset } = useMutation((_a) => __awaiter(void 0, [_a], void 0, function* ({ userUuid, ciamToken, survey_id, userInputCode }) {
        yield SurveyApi.init().validateSurveySerialCode(userUuid, ciamToken, survey_id, userInputCode);
    }));
    return {
        resetValidateSurveySerialCode: reset,
        validateSurveySerialCode: mutateAsync,
        validateSurveySerialCodeError: error,
        isValidateSurveySerialCodeError: isError,
        isValidateSurveySerialCodeLoading: isLoading,
    };
};
//# sourceMappingURL=useSurveys.js.map